const HeroSlider = ( $ ) => {
	const bannerSlider = $('.banner-slider'),
        collectionSlider = $('.collection-cards'),
        projectsSlider = $('.projects-items'),
        gallerySlider = $('.gallery-items'),
        productSlider = $('.product-slider'),
        productSliderNav = $('.product-slider-nav'), 
        infoItems = $('.info-items'),
        productItems = $('.product-items'),
        arrowNext = "<i class='icon-arrow-right'></i>",
        arrowPrev = "<i class='icon-arrow-left'></i>";
    if(bannerSlider.length){
        bannerSlider.slick({
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: true,
            autoplaySpeed: 3000,
        }); 
    }
    if(collectionSlider.length){
        collectionSlider.each(function(i, elm){  
            if($(elm).children().length >= 4){ 
                $(elm).slick({
                    infinite: true,
                    speed: 300,
                    centerMode: false,
                    slidesToShow: 3, 
                    prevArrow: arrowPrev,
                    nextArrow: arrowNext,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                            }
                           }
                    ]
                });
            }else{
                if($(window).width() <= 767){
                    $(elm).slick({
                        infinite: true,
                        speed: 300,
                        slidesToShow: 2, 
                        prevArrow: arrowPrev,
                        nextArrow: arrowNext,
                        variableWidth: true,
                    });
                }
            }
        })
    }
    if(projectsSlider.length){
        projectsSlider.slick({
            slidesToShow: 1,
            infinite: true,
            variableWidth: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext, 
            autoplaySpeed: 5000, 
            cssEase: 'linear',
            speed: 500,
        });
    }
    if(gallerySlider.length){
        gallerySlider.slick({
            slidesToShow: 6,
            infinite: true,
        prevArrow: arrowPrev,
            nextArrow: arrowNext,
            speed: 500,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });
    }
    if(productSlider.length){
        productSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.product-slider-nav'
        });
    }
    if(productSliderNav.length){
        productSliderNav.slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            asNavFor: '.product-slider',
            dots: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext, 
            centerMode: false,
            focusOnSelect: true
        });
        productSliderNav.find('.slick-dots li').each(function( index){
            $(this).preventDefault();
            $(this).attr('data-number', index + 1); 
        });
    }
    if($(window).width() < 768){
        if(infoItems.length){
            infoItems.slick({
                slidesToShow: 1,
                infinite: true,
                centerMode: true,
                prevArrow: arrowPrev,
                nextArrow: arrowNext,
            })
        }
    }
    if(productItems.length){
        if(productItems.children().length > 4){
            productItems.slick({
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                prevArrow: arrowPrev, 
                nextArrow: arrowNext,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            variableWidth: true,
                        }
                    }
                ]
            });
        }else{
            if($(window).width() < 768){
                productItems.addClass('square');
                productItems.slick({
                    infinite: true,
                    speed: 300,
                    slidesToShow: 2,
                    variableWidth: true,
                    prevArrow: arrowPrev, 
                    nextArrow: arrowNext,
                    autoplay: true,
                    autoplaySpeed: 3000,
                });
            }
        }
    }
};

export default ( ( $ ) => $( HeroSlider ) )( jQuery );
